import React from 'react';
import { Box } from '@mui/material';

const MainLayout = ({ 
  stepperContent, 
  workspaceContent, 
  chatDrawerContent,
  chatDrawerOpen = true,
  chatDrawerWidth = 400,
  noWorkspaceOverflow = false 
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    }}>
      {/* Stepper Section - Fixed Width */}
      <Box
        sx={{
          width: 320,
          flexShrink: 0,
          borderRight: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          overflowY: 'auto',
          height: '100%'
        }}
      >
        {stepperContent}
      </Box>

      {/* Workspace Section - Flexible Width */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100%',
          overflowY: noWorkspaceOverflow ? 'hidden' : 'auto',
          bgcolor: 'background.default',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {workspaceContent}
      </Box>

      {/* Chat Drawer - Fixed Width */}
      {chatDrawerOpen && (
        <Box
          sx={{
            width: chatDrawerWidth,
            flexShrink: 0,
            borderLeft: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {chatDrawerContent}
        </Box>
      )}
    </Box>
  );
};

export default MainLayout;